import { AtLeast } from '../utility-types';
import { CompositeKeys } from './composite-keys';
import { KeyActionName } from './key-action-names';
import { KeyEventType } from './key-event-type';

/**
 * Note: Priority might be duplicated.
 * If priority is duplicated, it means that actions will be triggered together.
 * Current priority implementation rely on prioritization of all the actions by the developer.
 */
export interface IHotKeySettings<T = KeyActionName> {
  keyActionName: T;
  compositeKeys: CompositeKeys[];
  keyEventType: KeyEventType;
  priority: number;
  isActive: boolean;
}

export class HotKeySettings<T extends KeyActionName> {
  keyActionName: T;
  compositeKeys: CompositeKeys[];
  keyEventType: KeyEventType;
  priority: number;
  isActive: boolean;

  constructor(settings: AtLeast<IHotKeySettings<T>, 'keyActionName'>) {
    this.keyActionName = settings.keyActionName;
    this.compositeKeys = settings.compositeKeys ?? [];
    this.keyEventType = settings.keyEventType ?? 'keydown';
    this.priority = settings.priority || 1;
    this.isActive = settings.isActive ?? true;
  }
}

export type UpdateHotKeySettings<T extends KeyActionName> = Partial<
  Omit<IHotKeySettings<T>, 'keyActionName'>
>;
